import styled from 'styled-components';

import TotalExperienceBase from './TotalExperienceBase';

const TotalExperience = styled(TotalExperienceBase)`
  text-align: center;
  padding: 1em;
`;

export default TotalExperience;
